import { gql } from "@apollo/client";

const PROVIDER_FIELDS = `
  id
  name
  type
  isActive
  website
  documentationUrl
  mainContactName
  mainContactEmail
  mainContactPhone
  contacts {
    id
    providerId
    contactType
    name
    email
  }
  createdAt
  updatedAt
`;

export const GET_PROVIDERS = gql`
  query GetProviders($name: String, $type: ProviderType, $includeInactive: Boolean = false, $pageSize: Int = 50, $pageNumber: Int = 0) {
    providers(name: $name, type: $type, includeInactive: $includeInactive, pageSize: $pageSize, pageNumber: $pageNumber) {
      count
      pageSize
      pageNumber
      items {
        ${PROVIDER_FIELDS}
      }
    }
  }
`;

export const GET_PROVIDER_BY_ID = gql`
  query GetProvider($id: UUID!) {
    provider(id: $id) {
      ${PROVIDER_FIELDS}
    }
  }
`;
